import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const GET_ORG_FACULTY = gql`
  query GetOrgFaculty($id: ID!) {
    getOrgFaculty(id: $id) {
      _id
      abbreviation
      title
      effectiveFrom
      effectiveTo
      isActive
      school
      frcSecretaries {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      frcChair {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      dean {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
    }
  }
`;

export const useGetOrgFaculty = (id: string): any => {
  const { data, loading, error } = useQuery(GET_ORG_FACULTY, {
    variables: { id },
    fetchPolicy: 'network-only',
  });

  return { data, loading, error };
};
